"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var zod_1 = require("zod");
// FIXME zod로 구현할 필요가 있을까?
var roomTypeFilterItemSchema = zod_1.z.object({
    /** 식별자 */
    roomTypeIds: zod_1.z.array(zod_1.z.number()),
    /** bottom-sheet에 노출되는 item */
    optionText: zod_1.z.string(),
    /**
     * packages/ui/components/select-box 에 사용하는 SelectBox.RightFixedContent 컴포넌트의 props
     * select-box에 선택된 값을 노출할 때 필요한 타입
     * */
    selectBoxContent: zod_1.z.object({ lineClampedText: zod_1.z.string(), fixedText: zod_1.z.string() }),
});
